import { Field, ErrorMessage, FormikErrors, FormikTouched } from 'formik';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { TranslatableFieldLabel } from '@/components/composite/TranslatableFieldLabel';
import { QuestionFormValues } from '@/utils/forms/questionTransformers';

interface OptionTextFieldsProps {
  index: number;
  optionTextEn: string;
  optionTextFr: string;
  errors?: FormikErrors<QuestionFormValues['options'][number]>;
  touched?: FormikTouched<QuestionFormValues['options'][number]>;
  translateField: (
    sourceKey: string,
    sourceValue: string,
    targetKey: string,
    setFieldValue: any
  ) => void;
  isFieldTranslating: (key: string) => boolean;
  setFieldValue: (field: string, value: any) => void;
  isEditable: boolean;
}

export function OptionTextFields({
  index,
  optionTextEn,
  errors,
  touched,
  translateField,
  isFieldTranslating,
  setFieldValue,
  isEditable,
}: OptionTextFieldsProps) {
  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="flex flex-col gap-2">
        <TranslatableFieldLabel
          htmlFor={`options.${index}.option_text_en`}
          onTranslate={() =>
            translateField(
              `option_${index}_text_en`,
              optionTextEn,
              `options.${index}.option_text_fr`,
              setFieldValue
            )
          }
          isTranslating={isFieldTranslating(`option_${index}_text_en`)}
        >
          Option Text (English)
        </TranslatableFieldLabel>
        <Field
          as={Input}
          name={`options.${index}.option_text_en`}
          data-test-id={`question-option-${index}-option_text_en`}
          placeholder="Enter option text"
          disabled={!isEditable}
          className={errors?.option_text_en && touched?.option_text_en ? 'border-red-500' : ''}
        />
        <ErrorMessage name={`options.${index}.option_text_en`}>
          {msg => <span className="text-sm text-red-500">{msg}</span>}
        </ErrorMessage>
      </div>

      <div className="flex flex-col gap-2">
        <Label>Option Text (French)</Label>
        <Field
          as={Input}
          name={`options.${index}.option_text_fr`}
          data-test-id={`question-option-${index}-option_text_fr`}
          placeholder="Enter option text"
          disabled={!isEditable}
          className={errors?.option_text_fr && touched?.option_text_fr ? 'border-red-500' : ''}
        />
        <ErrorMessage name={`options.${index}.option_text_fr`}>
          {msg => <span className="text-sm text-red-500">{msg}</span>}
        </ErrorMessage>
      </div>
    </div>
  );
}
